import styled from "styled-components";

const WrapMainApp = styled.div`
  padding: 5px;
  color: #000;

  @media (min-width: 600px) {
    width: 600px;
  }

  @media (max-width: 300px) {
    width: 300px;
  }
`;

const WrapBoxSection = styled.div`
  border: 1px solid #ebebeb;
  padding: 5px;
  background-color: #ffffff;
`;

const WrapPreviewSection = styled.div`
  margin-top: 10px;
  background-color: #ffffff;
  margin-bottom: 10px;
`;

export { WrapMainApp, WrapBoxSection, WrapPreviewSection };



// WEBPACK FOOTER //
// ./src/containers/App/Main.styled.ts